import React from 'react'

import PropTypes from 'prop-types'

const TopicTitle = ({ text }) => {
  if (!text) return <></>

  return (
    <div className="topicTitle">
      <h2>{text}</h2>
    </div>
  )
}

TopicTitle.propTypes = {
  text: PropTypes.string,
}

export default TopicTitle
